import React from 'react'

export const LinkedInIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g transform="translate(0 24) rotate(-90)">
        <g transform="translate(24) rotate(90)">
          <rect width="23" height="23" rx="2.833" transform="translate(0.5 0.5)" fill="#fff" />
          <path
            d="M0,2.005A2.005,2.005,0,0,1,2.005,0H22a2,2,0,0,1,2,2.005V22a2,2,0,0,1-2,2H2.005A2,2,0,0,1,0,22ZM9.5,9.15h3.25v1.633A3.722,3.722,0,0,1,16.223,9C19.68,9,20.5,10.869,20.5,14.3V20.65H17V15.08c0-1.953-.469-3.054-1.66-3.054-1.652,0-2.34,1.187-2.34,3.054V20.65H9.5ZM3.5,20.5H7V9H3.5Zm4-15.25A2.25,2.25,0,1,1,5.25,3,2.25,2.25,0,0,1,7.5,5.25Z"
            transform="translate(0 0)"
            fill="#0077b5"
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  )
}
